<ng-container *transloco="let t; prefix: 'update-payment-method-dialog'">
    <div
        mat-dialog-title
        class="dialog-title-container"
    >
        <h2 class="dialog-title">{{ t("Title") }}</h2>
        <button mat-icon-button (click)="close()" class="close-button">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <mat-dialog-content class="mat-typography">
        <form [formGroup]="paymentForm" class="payment-form">
            <div class="form-section">
                <h3 class="section-title">{{ t("CreditCardSection.Title") }}</h3>
                <div class="form-row">
                    <mat-form-field class="form-field-full v2-form-field">
                        <mat-label>{{ t("CreditCardSection.CardHolderName") }}</mat-label>
                        <input matInput formControlName="cardHolderName" required>
                        @if (paymentForm.get('cardHolderName')?.hasError('required') && paymentForm.get('cardHolderName')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row">
                <mat-form-field class="form-field-full v2-form-field">
                        <mat-label>{{ t("CreditCardSection.CardNumber") }}</mat-label>
                        <input matInput formControlName="cardNumber" [imask]="creditCardNumberMask" [unmask]="true" required>
                        @if (paymentForm.get('cardNumber')?.hasError('required') && paymentForm.get('cardNumber')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-half v2-form-field">
                        <mat-label>{{ t("CreditCardSection.Expiry") }}</mat-label>
                        <input matInput formControlName="cardExpiry" [imask]="creditCardExpiryMask" [placeholder]="t('CreditCardSection.ExpiryPlaceholder')" required>
                        @if (paymentForm.get('cardExpiry')?.hasError('required') && paymentForm.get('cardExpiry')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-field-half v2-form-field">
                        <mat-label>{{ t("CreditCardSection.CVC") }}</mat-label>
                        <input matInput formControlName="cardCvc" required>
                        @if (paymentForm.get('cardCvc')?.hasError('required') && paymentForm.get('cardCvc')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>

            <div class="form-section">
                <h3 class="section-title">{{ t("BillingSection.Title") }}</h3>
                <div class="form-row">
                    <mat-form-field class="form-field-full v2-form-field">
                        <mat-label>{{ t("BillingSection.NameOrCompany") }}</mat-label>
                        <input matInput formControlName="billingName" required>
                        @if (paymentForm.get('billingName')?.hasError('required') && paymentForm.get('billingName')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-full v2-form-field">
                        <mat-label>{{ t("BillingSection.CpfCnpj") }}</mat-label>
                        <input type="text" matInput formControlName="billingCpfCnpj" [imask]="fiscalIdentifierMask" [unmask]="true" required>
                        @if (paymentForm.get('billingCpfCnpj')?.hasError('required') && paymentForm.get('billingCpfCnpj')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.Email") }}</mat-label>
                        <input matInput formControlName="billingEmail" type="email" required>
                        @if (paymentForm.get('billingEmail')?.hasError('required') && paymentForm.get('billingEmail')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                        @if (paymentForm.get('billingEmail')?.hasError('email') && paymentForm.get('billingEmail')?.touched) {
                            <mat-error>
                                {{ t("Errors.InvalidEmail") }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.Phone") }}</mat-label>
                        <input matInput formControlName="billingPhone" [imask]="phoneMask" [unmask]="true" required>
                        @if (paymentForm.get('billingPhone')?.hasError('required') && paymentForm.get('billingPhone')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-small v2-form-field">
                        <mat-label>{{ t("BillingSection.Cep") }}</mat-label>
                        <input matInput formControlName="billingCep" [imask]="postalCodeMask" [unmask]="true" required>
                        @if (paymentForm.get('billingCep')?.hasError('required') && paymentForm.get('billingCep')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                        @if (invalidPostalCode) {
                            <mat-error>
                                {{ t("InvalidPostalCode") }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.Street") }}</mat-label>
                        <input matInput formControlName="billingStreet" required>
                        @if (paymentForm.get('billingStreet')?.hasError('required') && paymentForm.get('billingStreet')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-field-small v2-form-field">
                        <mat-label>{{ t("BillingSection.Number") }}</mat-label>
                        <input matInput formControlName="billingNumber" required>
                        @if (paymentForm.get('billingNumber')?.hasError('required') && paymentForm.get('billingNumber')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.Complement") }}</mat-label>
                        <input matInput formControlName="billingComplement">
                    </mat-form-field>
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.Reference") }}</mat-label>
                        <input matInput formControlName="billingReference">
                    </mat-form-field>
                </div>
                <div class="form-row">
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.Neighborhood") }}</mat-label>
                        <input matInput formControlName="billingNeighborhood" required>
                        @if (paymentForm.get('billingNeighborhood')?.hasError('required') && paymentForm.get('billingNeighborhood')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-field-medium v2-form-field">
                        <mat-label>{{ t("BillingSection.City") }}</mat-label>
                        <input matInput formControlName="billingCity" required>
                        @if (paymentForm.get('billingCity')?.hasError('required') && paymentForm.get('billingCity')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                    <mat-form-field class="form-field-tiny v2-form-field">
                        <mat-label>{{ t("BillingSection.State") }}</mat-label>
                        <input matInput formControlName="billingState" maxlength="2" required>
                        @if (paymentForm.get('billingState')?.hasError('required') && paymentForm.get('billingState')?.touched) {
                            <mat-error>
                                {{ t("Errors.Required") }}
                            </mat-error>
                        }
                    </mat-form-field>
                </div>
            </div>
        </form>
    </mat-dialog-content>

    <mat-dialog-actions align="end" class="dialog-actions-container">
        <v2-button-wrapper
            color="primary"
            [text]="submitting ? t('Actions.Processing') : t('Actions.Save')"
            variant="raised"
            icon="check"
            class="w-auto"
            type="button"
            [disabled]="submitting"
            (click)="onSave()"
        ></v2-button-wrapper>
    </mat-dialog-actions>
</ng-container>

